import { render, staticRenderFns } from "./UserSecurityHistoryNfa.vue?vue&type=template&id=21d56205&scoped=true&"
import script from "./UserSecurityHistoryNfa.vue?vue&type=script&lang=js&"
export * from "./UserSecurityHistoryNfa.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurityHistoryNfa.vue?vue&type=style&index=0&id=21d56205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d56205",
  null
  
)

export default component.exports